module.exports = __webpack_public_path__ + "static/media/elife-school-2024-12.c16a3b2c.gif";